import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button className="language-switcher" onClick={toggleLanguage} aria-label="Toggle language">
      <span className={`lang-option ${language === 'en' ? 'active' : ''}`}>EN</span>
      <span className="lang-divider">|</span>
      <span className={`lang-option ${language === 'ar' ? 'active' : ''}`}>AR</span>
    </button>
  );
};

export default LanguageSwitcher;
